import KeenSlider from "keen-slider";

class QuotesSlider {
  constructor() {
    const el = document.querySelector(".c-trust");
    if (!el) return;
    this.main = el.querySelector(".c-trust-cards");
    if (!this.main) return;
    this.arrowsPrev = el.querySelector(".c-trust-arrows .c-trust-arrow-prev");
    this.arrowsNext = el.querySelector(".c-trust-arrows .c-trust-arrow-next");

    var quoteslider = new KeenSlider(
      this.main,
      {
        loop: true,
        selector: ".c-trust-card-out",
        // created: () => {
        //   console.log("created");
        // },
        breakpoints: {
          "(min-width: 991px)": {
            disabled: true,
          },
        },
      },
      []
    );

    if (this.arrowsPrev && this.arrowsNext) {
      this.arrowsNext.addEventListener("click", function () {
        quoteslider.next();
      });
      this.arrowsPrev.addEventListener("click", function () {
        quoteslider.prev();
      });
    }
  }
}

export default QuotesSlider;
